import { useThemeContext } from '../../hook/useThemeManager';
import CustomLazyLoadImage from '../Image/CustomLazyLoadImage';
import lamp from '../../asset/images/icons/lamp_thspian.svg';
import light from '../../asset/images/icons/circular_light_thspian.svg';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

interface ISpotlight {
    withoutBg?: boolean;
    position?: string | number;
}
const Spotlight: React.FC<ISpotlight> = ({ withoutBg, position }) => {
    const { darkModeEnabled } = useThemeContext();
    const muiTheme = useTheme();
    const over1200 = useMediaQuery(muiTheme.breakpoints.up(1200));

    if (!darkModeEnabled) {
        return null;
    }
    // Default position logic (old behavior preserved)
    const defaultLeft = over1200 && !withoutBg ? '30%' : '50%'; // Exact center of left panel (60% width = 30% from left)

    // Position applied (prop overrides default)
    const lampPosition = position ?? defaultLeft;

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: lampPosition,
                transform: 'translateX(-50%)',
                zIndex: 0, // Behind the container
                width: over1200 ? '60%' : '100%', // Match the left panel width
                height: '100vh',
                pointerEvents: 'none',
            }}>
            {/* Lamp positioned at the very top center with physics-based swinging */}
            <CustomLazyLoadImage
                src={lamp}
                style={{
                    width: over1200 && !withoutBg ? '25%' : withoutBg ? '40%' : '30%',
                    height: '80px',
                    position: 'absolute',
                    top: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 1,
                    animation: 'lampSwing 3s ease-in-out infinite',
                    transformOrigin: 'top center',
                }}
            />

            {/* Light with swinging animation that follows the lamp */}
            <CustomLazyLoadImage
                src={light}
                style={{
                    width: '100%',
                    height: '100vh',
                    position: 'absolute',
                    top: 60,
                    left: 0,
                    opacity: '60%',
                    animation: 'lightSwing 3s ease-in-out infinite',
                    transformOrigin: 'top center',
                }}
            />

            <style>
                {`
                    @keyframes lampSwing {
                        0%, 100% {
                            transform: translateX(-50%) rotate(-4deg);
                        }
                        50% {
                            transform: translateX(-50%) rotate(4deg);
                        }
                    }
                    
                    @keyframes lightSwing {
                        0%, 100% {
                            transform: rotate(-4deg);
                        }
                        50% {
                            transform: rotate(4deg);
                        }
                    }
                `}
            </style>
        </Box>
    );
};

export { Spotlight };
